import type {Builder, PS} from '@wix/document-services-types'

const registerBuilderComponent: RegisterBuilderComponent = (
    ps: PS,
    identifier: string,
    manifest: Builder.Manifest
): void => ps.extensionAPI.builderComponents.registerBuilderComponentWithManifest(identifier, manifest)

const getCompAppData = (ps: PS, componentType: string) => ps.extensionAPI.platform.getBuilderCompAppData(componentType)
export type RegisterBuilderComponent = (ps: PS, identifier: string, manifest: Builder.Manifest) => void
export default {
    registerBuilderComponent,
    getCompAppData
}
